import React from 'react';
import { Box, Step, StepLabel, Stepper } from '@mui/material';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import { Colors } from '../../../utils/theme';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)'
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: Colors.green
    }
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: Colors.green
    }
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: Colors.gray,
    borderTopWidth: 2
  }
}));

interface IProps {
  steps: string[];
  activeStep: number;
}

const FormStepper: React.FunctionComponent<IProps> = ({ steps, activeStep }: IProps) => {
  return (
    <Box sx={{ pt: '30px' }}>
      <Stepper activeStep={activeStep} alternativeLabel connector={<QontoConnector />}>
        {steps.map((label) => (
          <Step
            key={label}
            sx={{
              padding: 0,
              '& .MuiStepLabel-root .Mui-completed': {
                color: Colors.green // circle color (COMPLETED)
              },
              '& .MuiStepLabel-root .Mui-active': {
                color: '#caedff' // circle color (ACTIVE)
              },
              '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel': {
                color: 'primary.main' // Just text label (ACTIVE)
              },
              '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                fill: Colors.main,
                fontWeight: 'bold' // circle's number (ACTIVE)
              }
            }}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default FormStepper;
